import { tagTheme } from '@taglivros/tag-components'
import styled from 'styled-components'


const Container = styled.a<Container.Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 0;
  background-color: ${props => props.theme.cores[ props.$backgroundColor ]};
  border: solid 1px ${props => props.theme.cores[ props.$border ]};
  border-radius: 8px;
  color: ${props => props.theme.cores[ props.$color ]};
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    background-color: ${props => props.theme.cores[ props.$hover ]};
    transition: .2s ease-in-out;
  }
`
namespace Container {
  export interface Props {
    $backgroundColor: keyof typeof tagTheme.cores
    $border: keyof typeof tagTheme.cores | 'none'
    $color: keyof typeof tagTheme.cores
    $hover: keyof typeof tagTheme.cores
  }
}

export { Container }
